import {Decryption, Encryption} from "ubs-framework/v2/common/function";

export const setLocal = (key, value) => {
    localStorage.setItem(key, Encryption(value));
};
export const getLocal = (key) => {
    return Decryption(localStorage.getItem(key));
};